import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { Routes } from '../../../constants/routes';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';

export class WorkloadDetailsDrawer extends Component {

    onLocationClick = (location) => {

        const urlParams = {
            locationKeys: [location.locationKey]
        };
        NavigateToRouteWithDashboardParams(Routes.DashboardLocation, urlParams, false);
    }

    render() {

        return (
            <Drawer isWide={false}
                onCancelClick={this.props.onComplete}
                saveText='Close'
                title="Workload Detail">
                <LoadingIndicator isLoading={this.props.isLoading} hideWhileLoading={true}>
                    <div className="workload-details-drawer">
                        <div><strong>{this.props.seriesName}</strong></div>
                        <div>{this.props.dateRangeStart} - {this.props.dateRangeEnd}</div>
                        <div className="row m-1">
                            { this.props.locations && this.props.locations.length > 0 ?
                                <ul className="list-group list-group-flush w-100">
                                    {this.props.locations.map(loc => {
                                        return (
                                            <li className="list-group-item d-flex justify-content-between align-items-center" key={loc.locationKey} onClick={() => this.onLocationClick(loc)}>
                                                {loc.locationName}
                                                <span className="badge bg-primary rounded-pill" >{loc.taskCount}</span>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                                : <p>No locations found.</p>
                            }
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer>
        )
    }
}

WorkloadDetailsDrawer.propTypes = {
    seriesName: PropTypes.string.isRequired,
    dateRangeStart: PropTypes.string.isRequired,
    dateRangeEnd: PropTypes.string.isRequired,
    locations: PropTypes.array,
    onComplete: PropTypes.func.isRequired,
    companyDashboardActions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    settings: PropTypes.object
};

export default WorkloadDetailsDrawer;